/* =========================================================
   ES Wishlist Badge State (dot only)
   - Desktop + mobile header show a small dot (not a number).
   - Persist a lightweight "has wishlist items" flag in localStorage
     so the dot does not flash off/on during navigation.
   - Optimized to dedupe timers and reduce observer churn.
   ========================================================= */
(function () {
  'use strict';

  if (window.__esWishlistBadgeCleanup) {
    try { window.__esWishlistBadgeCleanup(); } catch (e) {}
  }

  var KEY_HAS = 'es_wl_confirmed_has_items';
  var KEY_TS  = 'es_wl_confirmed_ts';
  var queued = Object.create(null);
  var stopMutationWatch = null;
  var bootstrapped = false;
  var domReadyHandler = null;
  var pageShowHandler = null;
  var pageHideHandler = null;
  var visibilityHandler = null;
  var addHandler = null;
  var removeHandler = null;

  function safeGet(key) {
    try { return (window.localStorage && localStorage.getItem(key)) || ''; }
    catch (e) { return ''; }
  }
  function safeSet(key, val) {
    try { if (window.localStorage) localStorage.setItem(key, val); }
    catch (e) {}
  }

  function setRootFlag(has) {
    var root = document.documentElement;
    if (!root || !root.classList) return;
    root.classList.toggle('es-wishlist-has-items', !!has);
  }

  function setMobileDot(has) {
    var els = document.querySelectorAll('.swym-wishlist-header-counter.swym-mobile');
    if (!els || !els.length) return;
    for (var i = 0; i < els.length; i++) {
      try { els[i].classList.toggle('show-badge', !!has); } catch (e) {}
    }
  }

  function textCount(txt) {
    txt = (txt || '').trim();
    if (!txt) return 0;
    if (txt === '9+') return 9;
    var n = parseInt(txt, 10);
    return isNaN(n) ? 0 : n;
  }

  function getBadges() {
    return Array.prototype.slice.call(document.querySelectorAll('.swym-wishlist-header-counter'));
  }

  function shouldShow(el) {
    if (!el) return false;
    try {
      if (el.classList && el.classList.contains('show-badge')) return true;
    } catch (e) {}
    return textCount(el.textContent) > 0;
  }

  function computeState() {
    var badges = getBadges();
    if (!badges.length) return { has: false, ready: false };

    var ready = !!(window.__esSwat || window._swat || window.SwymWishlist || window.Swym);
    var has = false;

    for (var i = 0; i < badges.length; i++) {
      if (shouldShow(badges[i])) {
        has = true;
        break;
      }
    }
    return { has: has, ready: ready };
  }

  function syncPersistedFlag() {
    var state = computeState();
    if (!state.ready) return;

    setRootFlag(state.has);
    setMobileDot(state.has);
    safeSet(KEY_HAS, state.has ? '1' : '0');
    safeSet(KEY_TS, String(Date.now()));
  }

  function clearQueued() {
    for (var k in queued) {
      if (!Object.prototype.hasOwnProperty.call(queued, k)) continue;
      try { clearTimeout(queued[k]); } catch (e) {}
      delete queued[k];
    }
  }

  function scheduleSync(ms) {
    ms = Math.max(0, ms | 0);
    if (document.visibilityState === 'hidden') return;
    if (queued[ms]) return;
    queued[ms] = setTimeout(function () {
      try { syncPersistedFlag(); } finally {
        try { clearTimeout(queued[ms]); } catch (e) {}
        delete queued[ms];
      }
    }, ms);
  }

  function hasAnyBadgeDom() {
    try { return !!document.querySelector('.swym-wishlist-header-counter'); }
    catch (e) { return false; }
  }

  (function applyCache(){
    try { setMobileDot(safeGet(KEY_HAS) === '1'); } catch (e) {}
  })();

  function disconnectObserver() {
    if (!stopMutationWatch) return;
    try { stopMutationWatch(); } catch (e) {}
    stopMutationWatch = null;
  }

  function nodeTouchesBadge(node) {
    if (!node) return false;
    if (node.nodeType === 3) node = node.parentElement;
    if (!node || node.nodeType !== 1) return false;
    try {
      if (node.matches && node.matches('.swym-wishlist-header-counter')) return true;
      if (node.closest && node.closest('.swym-wishlist-header-counter')) return true;
      return !!(node.querySelector && node.querySelector('.swym-wishlist-header-counter'));
    } catch (e) { return false; }
  }

  function wishlistMutations(mutations) {
    var shouldAttach = false;
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      if (mutation.type === 'attributes' || mutation.type === 'characterData') {
        if (nodeTouchesBadge(mutation.target)) {
          scheduleSync(30);
          return;
        }
        continue;
      }
      if (mutation.type === 'childList') {
        if (nodeTouchesBadge(mutation.target)) {
          scheduleSync(30);
          return;
        }
        for (var j = 0; j < mutation.addedNodes.length; j += 1) {
          if (nodeTouchesBadge(mutation.addedNodes[j])) {
            shouldAttach = true;
            break;
          }
        }
      }
      if (shouldAttach) break;
    }
    if (shouldAttach) {
      bootstrapped = false;
      bootstrap();
      scheduleSync(30);
    }
  }

  function attachObservers() {
    if (stopMutationWatch) return;
    var options = {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-es-wl-ready']
    };
    try {
      if (window.ES && window.ES.observe && typeof window.ES.observe.mutations === 'function') {
        stopMutationWatch = window.ES.observe.mutations(wishlistMutations, options, document.documentElement);
      } else if (window.MutationObserver) {
        var fallbackObserver = new MutationObserver(wishlistMutations);
        fallbackObserver.observe(document.documentElement, options);
        stopMutationWatch = function () { try { fallbackObserver.disconnect(); } catch (e) {} };
      }
    } catch (e) {
      stopMutationWatch = null;
      if (window.ES && typeof window.ES.warn === 'function') {
        window.ES.warn('wishlist-badge', 'Mutation watch failed.', e);
      }
    }
  }

  (function initFromCache(){
    try {
      var has = safeGet(KEY_HAS);
      var tsRaw = safeGet(KEY_TS);
      var ts = parseInt(tsRaw, 10) || 0;
      var ttl = 7 * 24 * 60 * 60 * 1000;
      if (has === '1' && (!ts || (Date.now() - ts) < ttl)) {
        setRootFlag(true);
        setMobileDot(true);
      } else if (has === '0') {
        setRootFlag(false);
        setMobileDot(false);
      }
    } catch (e) {}
  })();

  function bootstrap() {
    if (bootstrapped) return;
    bootstrapped = true;
    attachObservers();
    if (!hasAnyBadgeDom()) return;
    scheduleSync(150);
    scheduleSync(450);
    scheduleSync(1200);
    scheduleSync(2600);
  }

  domReadyHandler = bootstrap;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domReadyHandler);
  } else {
    bootstrap();
  }

  addHandler = function () {
    try {
      safeSet(KEY_HAS, '1');
      safeSet(KEY_TS, String(Date.now()));
      setRootFlag(true);
      setMobileDot(true);
    } catch (e) {}
    scheduleSync(120);
    scheduleSync(420);
    attachObservers();
  };
  document.addEventListener('swym:addedtowishlist', addHandler);

  removeHandler = function () {
    scheduleSync(120);
    scheduleSync(420);
    attachObservers();
  };
  document.addEventListener('swym:removedfromwishlist', removeHandler);

  pageShowHandler = function () {
    bootstrapped = false;
    bootstrap();
    scheduleSync(80);
  };
  window.addEventListener('pageshow', pageShowHandler);

  pageHideHandler = function () {
    clearQueued();
    disconnectObserver();
    bootstrapped = false;
  };
  window.addEventListener('pagehide', pageHideHandler);

  visibilityHandler = function () {
    if (document.visibilityState === 'hidden') {
      clearQueued();
      disconnectObserver();
      return;
    }
    bootstrapped = false;
    bootstrap();
    scheduleSync(80);
  };
  document.addEventListener('visibilitychange', visibilityHandler);

  window.__esWishlistBadgeCleanup = function () {
    clearQueued();
    disconnectObserver();
    bootstrapped = false;
    if (domReadyHandler) document.removeEventListener('DOMContentLoaded', domReadyHandler);
    if (addHandler) document.removeEventListener('swym:addedtowishlist', addHandler);
    if (removeHandler) document.removeEventListener('swym:removedfromwishlist', removeHandler);
    if (visibilityHandler) document.removeEventListener('visibilitychange', visibilityHandler);
    if (pageShowHandler) window.removeEventListener('pageshow', pageShowHandler);
    if (pageHideHandler) window.removeEventListener('pagehide', pageHideHandler);
  };
})();
